<template>
  <div class="main">
    <CreditCardShowPin
      v-if="currentStep === 'show-pin'"
      @showPinChange="currentStep = 'pin-change'"
      :biometric-verified="biometricVerified"
    />
    <CreditCardPinChange v-if="currentStep === 'pin-change'" />
  </div>
</template>

<script setup>
import CreditCardPinChange from "@/apps/credit-line/components/CreditCard/CreditCardPinChange.vue";
import CreditCardShowPin from "@/apps/credit-line/components/CreditCard/CreditCardShowPin.vue";
import { ref } from "vue";
import { useRoute } from "vue-router";

const currentStep = ref("show-pin");
const route = useRoute();
// Default to false when route params are unavailable (e.g. unit tests without a router)
const biometricVerified = route?.query?.biometricVerified === "true";
</script>

<style lang="scss" scoped></style>
